<div class="row">
  <div class="col-xs-12 col-12">
    <pagination [boundaryLinks]="showBoundaryLinks" [totalItems]="55"></pagination>
  </div>
</div>

<button type="button" class="btn btn-info" (click)="showBoundaryLinks = !showBoundaryLinks">Hide/show boundary links</button>
